import { Link } from "react-router-dom";
import { genres, comics } from "@/mocks/comics";

const genreMeta: Record<string, { icon: string; desc: string }> = {
  少年: { icon: "ri-sword-line", desc: "热血成长" },
  少女: { icon: "ri-heart-3-line", desc: "细腻心动" },
  青年: { icon: "ri-user-star-line", desc: "深度现实" },
  同人: { icon: "ri-group-line", desc: "二次创作" },
  奇幻: { icon: "ri-magic-line", desc: "恢弘世界观" },
  科幻: { icon: "ri-planet-line", desc: "未来畅想" },
  恋爱: { icon: "ri-heart-line", desc: "甜蜜物语" },
  动作: { icon: "ri-fire-line", desc: "酣畅战斗" },
};

export default function GenreGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            题材分类
          </h2>
          <p className="mt-1 text-sm text-foreground-500">按题材快速找到心仪的作品</p>
        </div>
        <Link
          to="/category"
          className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-3 md:gap-4">
        {genres.map((genre) => {
          const meta = genreMeta[genre];
          const count = comics.filter((comic) => comic.genres.includes(genre)).length;
          return (
            <Link
              key={genre}
              to={`/category?genre=${encodeURIComponent(genre)}`}
              className="group p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-400 transition-all duration-300"
            >
              <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-500 flex items-center justify-center mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${meta.icon} text-xl`} />
              </span>
              <h3 className="font-heading font-semibold text-sm text-foreground-950">{genre}</h3>
              <p className="mt-1 text-xs text-foreground-500">{meta.desc}</p>
              <p className="mt-2 text-xs text-accent-500">{count} 部作品</p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}